import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Services', href: '#services' },
  { label: 'Markets', href: '#markets' },
  { label: 'Projects', href: '#projects' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-charcoal/95 backdrop-blur-md border-b border-charcoal-border'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-3 cursor-pointer flex-shrink-0">
          <img
            src="https://static.readdy.ai/image/6a75c8943ff93b9f13637580546a6144/e2221da1d169b5e9c147ffef050da574.png"
            alt="ABUMI Trading Company Limited"
            className="h-12 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="nav-link text-[#B0B0B0] hover:text-gold text-xs font-medium tracking-[0.18em] uppercase cursor-pointer whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            className="ml-4 px-6 py-2.5 border border-gold text-gold text-xs font-semibold tracking-[0.14em] uppercase hover:bg-gold hover:text-charcoal transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Get In Touch
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden w-10 h-10 flex flex-col justify-center items-center gap-1.5 cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-px bg-gold transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2.5' : ''}`} />
          <span className={`block w-6 h-px bg-gold transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-px bg-gold transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2.5' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-400 ${
          menuOpen ? 'max-h-80' : 'max-h-0'
        } bg-charcoal-light border-b border-charcoal-border`}
      >
        <div className="px-6 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="text-[#B0B0B0] hover:text-gold text-xs font-medium tracking-[0.18em] uppercase cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            onClick={() => setMenuOpen(false)}
            className="mt-2 px-6 py-2.5 border border-gold text-gold text-xs font-semibold tracking-[0.14em] uppercase text-center hover:bg-gold hover:text-charcoal transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Get In Touch
          </a>
        </div>
      </div>
    </nav>
  );
}
